import { render } from "./Mail.vue?vue&type=template&id=b15b7bbe&scoped=true"
const script = {}

import _style_0 from "./Mail.vue?vue&type=style&index=0&id=b15b7bbe&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-b15b7bbe"]])

export default __exports__